import React, { useState } from "react";
import { Modal, Select, message } from "antd";
import postData, { postDataAPI } from "../../hooks/fetchApi";
import NumericInput from "react-numeric-input";

function AddPayment(props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [disable, setDisable] = useState(false);
  const [data, setData] = useState({
    user_id: null,
    amount: 150,
    password: "123456",
    users: [],
    units: [],
  });

  const users = () => {
    postData({
      service: "get_users",
      data: {
        property: "active",
        items: "1000",
        offset: "0",
      },
    }).then((resp) => {
      if (resp.success === 1) {
        data.users = resp.data.map((u) => {
          return {
            value: u.user_id,
            label: `${u.first_name} ${u.last_name}`,
          };
        });

        setData({ ...data });
      }
    });
  };


  React.useEffect(() => {
    users();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = () => {
    if (data.user_id == null) {
      message.error("Please select user");
      return;
    } else if (data.amount.toString().trim().length === 0) {
      message.error("Please enter amount");
      return;
    } else {
      setDisable(true);
      postDataAPI({
        service: "pay_investor",
        data: {
          user_id: data.user_id,
          amount: data.amount,
          password: data.password,
        },
      }).then((resp) => {
        console.log(resp)
        setDisable(false);
        if (resp.success === 1) {
          props.addPayment();
          setIsModalOpen(false);
          message.success(resp.message);
        } else message.error(resp.message);
      });
    }
  };

  return (
    <div className="form_data">
      <button
        onClick={() => {
          data.user_id = null;
          data.amount = 150;
          setData({ ...data });
          setIsModalOpen(true);
        }}
        className="px-8 py-2 text-sm text-white rounded-md"
      >
        Add Payment
      </button>
      <Modal
        title="Add Investment"
        open={isModalOpen}
        footer={[]}
        maskClosable={false}
        width={500}
        onOk={() => {
          setIsModalOpen(false);
        }}
        onCancel={() => {
          setIsModalOpen(false);
        }}
      >
        <div className="mt-6">

          <div className="mt-6">
            <p>User</p>
            <Select
              showSearch
              style={{
                width: "100%",
              }}
              onChange={(v) => {
                data.user_id = v;
                setData({ ...data });
              }}
              value={data.user_id}
              placeholder="Search to select User"
              optionFilterProp="children"
              filterOption={(input, option) =>
                ((option?.label).toLowerCase() ?? "").includes(input)
              }
              filterSort={(optionA, optionB) =>
                (optionA?.label ?? "")
                  .toLowerCase()
                  .localeCompare((optionB?.label ?? "").toLowerCase())
              }
              options={data.users}
            />
          </div>

          <div className="mt-4">
            <p>Amount</p>
            <NumericInput
              className="w-full p-2 border"
              min={150}
              step={1}
              value={data.amount}
              // eslint-disable-next-line
              style={false}
              onBlur={(e) => {
                data.amount = e.target.value;
                setData({ ...data });
              }}
            />
          </div>

          <button
            onClick={onSubmit}
            disabled={disable}
            className="px-4 py-2 mt-6 text-white rounded-md"
          >
            Submit
          </button>
        </div>
      </Modal>
    </div>
  );
}

export default AddPayment;